import { useHead } from '@unhead/react';
import { useState } from 'react';
import BarcodeScannerComponent from 'react-qr-barcode-scanner';
import { createSearchParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'translations/hooks';

import { ScanConfigV1OutputDto } from 'generated/apiSchemas';

export const Scanner = ({
  scanConfig,
  redirectLink,
}: {
  scanConfig: ScanConfigV1OutputDto;
  redirectLink: string;
}) => {
  const [data, setData] = useState<string | null>(null);
  const navigate = useNavigate();
  const { t } = useTranslation();

  useHead({
    title: t('qualityControl.segmentScan.title'),
  });

  return (
    <div>
      <h3>{t('qualityControl.segmentScan.title')}</h3>
      <BarcodeScannerComponent
        onUpdate={(_err, result) => {
          if (result) {
            setData(result.getText());
            const code = result
              .getText()
              .slice(
                scanConfig.startIndex,
                scanConfig.startIndex + scanConfig.extractLength,
              );
            navigate(
              `${redirectLink}${createSearchParams({ serialNumber: code })}`,
            );
          }
        }}
      />
      <p>
        {t('qualityControl.segmentScan.result', {
          result: data ?? t('qualityControl.segmentScan.noScan'),
        })}
      </p>
    </div>
  );
};
